import { useState, useEffect, forwardRef } from "react";

const ProgressiveImage = forwardRef(
    ({ lowResSrc, highResSrc, style, onLoad, onError, onClick }, ref) => {
        const [src, setSrc] = useState("");
        const [isLoaded, setIsLoaded] = useState(false);
        const [hasError, setHasError] = useState(false);
        const [lowResLoaded, setLowResLoaded] = useState(false);

        // First load the low-res image
        useEffect(() => {
            if (!lowResSrc) {
                // If no low-res image, start with high-res directly
                setSrc(highResSrc || "");
                return;
            }

            setSrc(lowResSrc);

            const img = new Image();
            img.src = lowResSrc;
            img.onload = () => {
                setLowResLoaded(true);
            };
        }, [lowResSrc]);

        // Only after low-res is loaded, start loading high-res
        useEffect(() => {
            if (!highResSrc || !lowResLoaded) return;

            const img = new Image();
            img.src = highResSrc;
            img.onload = () => {
                setSrc(highResSrc);
                setIsLoaded(true);
            };
            img.onerror = () => {
                console.error(
                    "Failed to load high resolution image:",
                    highResSrc
                );
                setHasError(true);
                if (onError) onError();
            };
        }, [highResSrc, onError, lowResLoaded]);

        const handleLoad = () => {
            if (onLoad) onLoad();
        };

        const handleError = () => {
            setHasError(true);
            if (onError) onError();
        };

        if (!lowResSrc && !highResSrc) {
            return (
                <div
                    className="map-image-placeholder"
                    style={{
                        backgroundColor: "#f0f0f0",
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        ...style,
                    }}
                >
                    Map not available
                </div>
            );
        }

        return (
            <img
                ref={ref}
                src={src}
                alt="map-background"
                className="map-image"
                onClick={onClick}
                onLoad={handleLoad}
                onError={handleError}
                style={style}
            />
        );
    }
);

export default ProgressiveImage;
